import {
  NOT
} from '../../../lib/Boolean.lib';
import {
  MatchPageController
} from '../MatchPage';
import onChangeJob from './onChangeJob.handler';

export default async function onToggleFilter() {
  const MatchPage = MatchPageController();
  MatchPage.setState(
    {
      yesSelectedJobExtendedFilter: NOT(
        MatchPage.state.yesSelectedJobExtendedFilter
      )
    },
    () => onChangeJob(
      MatchPage.state.selectedJobId
    )
  );
}
